"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var VisitStatusEnum;
(function (VisitStatusEnum) {
    VisitStatusEnum["Configured"] = "configured";
    VisitStatusEnum["Incomplete"] = "incomplete";
})(VisitStatusEnum = exports.VisitStatusEnum || (exports.VisitStatusEnum = {}));
function VisitFromJSON(json) {
    return VisitFromJSONTyped(json, false);
}
exports.VisitFromJSON = VisitFromJSON;
function VisitFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': json['email'],
        'phone': json['phone'],
        'customer': _1.CustomerSummary1FromJSON(json['customer']),
        'guests': !runtime_1.exists(json, 'guests') ? undefined : (json['guests'].map(_1.VisitGuestFromJSON)),
        'notify_on_create': json['notify_on_create'],
        'create_visit_notification_sent': json['create_visit_notification_sent'],
        'arrival_date': (new Date(json['arrival_date'])),
        'departure_date': (new Date(json['departure_date'])),
        'source': json['source'],
        'room_reservation': _1.VisitRoomReservationFromJSON(json['room_reservation']),
        'basket': !runtime_1.exists(json, 'basket') ? undefined : _1.BasketSummaryFromJSON(json['basket']),
        'visit_type': _1.VisitTypeSummaryFromJSON(json['visit_type']),
        'created_at': (new Date(json['created_at'])),
    };
}
exports.VisitFromJSONTyped = VisitFromJSONTyped;
function VisitToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': value.status,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'phone': value.phone,
        'customer': _1.CustomerSummary1ToJSON(value.customer),
        'guests': value.guests === undefined ? undefined : (value.guests.map(_1.VisitGuestToJSON)),
        'notify_on_create': value.notify_on_create,
        'create_visit_notification_sent': value.create_visit_notification_sent,
        'arrival_date': (value.arrival_date.toISOString().substr(0, 10)),
        'departure_date': (value.departure_date.toISOString().substr(0, 10)),
        'source': value.source,
        'room_reservation': _1.VisitRoomReservationToJSON(value.room_reservation),
        'basket': _1.BasketSummaryToJSON(value.basket),
        'visit_type': _1.VisitTypeSummaryToJSON(value.visit_type),
        'created_at': (value.created_at.toISOString()),
    };
}
exports.VisitToJSON = VisitToJSON;
